import PrimaryButton from "components/common/buttons/PrimaryButton";
import { DialogHeader, DialogBody } from "components/common/dialogs/GenericDialog";
import InputField from "components/common/forms/InputField";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { postRequest } from "lib/core/apiClient";
import { useLocale } from "lib/hooks/useLocale";
import React, { useState } from "react";
import { mutate } from "swr";
import GyftrIcon from "assests/images/GyftrLogo.png";
import { X } from "@phosphor-icons/react";
import AddGyftrContent from "./AddGyftrContent";
import RedeemGyftrContent from "./RedeemGyftrContent";

interface AddCouponDialog {
  gyftrBalance: number;
  modalType: "ADD" | "REDEEM";
  setModalType: React.Dispatch<React.SetStateAction<"ADD" | "REDEEM">>;
}

const AddCouponDialog: React.FC<AddCouponDialog> = ({ gyftrBalance, modalType, setModalType }) => {
  return (
    <>
      <DialogBody className="!pb-4 !pt-0" onClick={(e) => e.stopPropagation()}>
        {modalType === "ADD" ? (
          <AddGyftrContent setModalType={setModalType}  />
        ) : (
          <RedeemGyftrContent gyftrBalance={gyftrBalance} setModalType={setModalType} />
        )}
      </DialogBody>
    </>
  );
};

export default AddCouponDialog;
